 $(function(){
	  
	  $('.size__main').slick({
		  asNavFor:".size__thumb",
		  slidesToShow: 1,
		  dots: true
	  });
	  $('.size__thumb').slick({
		  asNavFor:".size__main",
		  slidesToShow: 4,
		  arrows: false
	  });
	  $(".size__thumb .slick-slide").on("click",function(){
		let index=$(this).attr("data-slick-index")
		$(".size__main").slick("slickGoTo",index)
	  });

      // if($('.variation__list__item').length > 12){
      //    if(window.innerWidth > 880) {
      //       $('.variation__wrap').after('<p class="js-variation-btn variation-btn">すべてのカラーを見る</p>');
      //    } else {
      //      $('.variation__wrap').after('<a class="variation-btn" href="#main-bottom">すべてのカラーを見る</a>');
      //    }
      //  }

        if(window.innerWidth > 880) {
         if($('.variation__list__item').length > 12) {
           $('.variation__wrap').after('<p class="js-variation-btn variation-btn">すべてのカラーを見る</p>');
         }
       }

       if(window.innerWidth < 880) {
         if($('.variation__list__item').length > 10) {
           $('.variation__wrap').after('<a class="variation-btn" href="#main-bottom">すべてのカラーを見る</a>');
         }
       }

      $('a[href^="#"]').click(function () {
          console.log('run')
          const speed = 600;
          let href = $(this).attr("href");
          let target = $(href == "#" || href == "" ? "html" : href);
          let position = target.offset().top;
          $("body,html").animate({ scrollTop: position }, speed, "swing");
          return false;
      });
  });
  $(window).on('load', function(){
      if($('.variation__list__item').length < 6 && window.innerWidth > 880) {
        $('.js-variation-list').css('justify-content', 'center');
      }
      if($('.variation__list__item').length > 12 && window.innerWidth > 880) {
        var auto = $('.variation__list').height();
        var hide = $('.variation__list__item').eq(0).height() + $('.variation__list__item').eq(6).height() + 25;
        var sec = $('.variation');
        console.log($('.variation__list__item').height())
        console.log(hide)
        $('.variation__list').css('height', hide);
        $('.js-variation-btn').on('click', function(){
          if(sec.hasClass('open')){
            sec.removeClass('open');
            $('.variation__list').animate({
              height: hide
            }, 500);
          }else {
            sec.addClass('open');
            $('.variation__list').animate({
              height: auto
            }, 500);
          }
        });
      }
      if(window.innerWidth < 880) {
        var listWidth = $('.variation__list__item').length * 150;
        if($('.variation__list__item').length >= 6) {
          // $('.js-variation-list').css('width', '900px');
        } else {
          $('.js-variation-list').css('width', listWidth);
        }
      }
  });

  $(window).on('load scroll', function () {
    
    var scroll = $(window).scrollTop();
    var windowH = $(window).height();
    var target = $('#main-bottom').offset().top;
    if (scroll > target - windowH) {
      $('.js-float-btn').fadeOut()
    }else if(scroll == 0){
	  $('.js-float-btn').fadeOut()
	} else {
      $('.js-float-btn').fadeIn().css('display', 'flex')
    }
    
  });